const FunderActionTypes = {
  /*****************  GET FUNDER LIST START  *******************/
  GET_FUNDER_LIST_START: "get_funder_list_start",
  GET_FUNDER_LIST_SUCCESS: "get_funder_list_success",
  GET_FUNDER_LIST_FAILURE: "get_funder_list_failure",
  GET_FUNDER_LIST_RESPONSE_RESET: "get_funder_list_response_reset",
  GET_FUNDER_LIST_RESPONSE_CHANGED: "get_funder_list_response_changed",
  /*****************  GET FUNDER LIST END  *******************/

  /*****************  ADD FUNDER DETAILS START  *******************/
  ADD_FUNDER_DETAILS_START: "add_funder_details_start",
  ADD_FUNDER_DETAILS_SUCCESS: "add_funder_details_success",
  ADD_FUNDER_DETAILS_FAILURE: "add_funder_details_failure",
  ADD_FUNDER_DETAILS_RESPONSE_RESET: "add_funder_details_response_reset",
  ADD_FUNDER_DETAILS_RESPONSE_CHANGED: "add_funder_details_response_changed",
  /*****************  ADD FUNDER DETAILS END  *******************/

  /*****************  UPDATE FUNDER DETAILS START  *******************/
  UPDATE_FUNDER_DETAILS_START: "update_funder_details_start",
  UPDATE_FUNDER_DETAILS_SUCCESS: "update_funder_details_success",
  UPDATE_FUNDER_DETAILS_FAILURE: "update_funder_details_failure",
  UPDATE_FUNDER_DETAILS_RESPONSE_RESET: "update_funder_details_response_reset",
  UPDATE_FUNDER_DETAILS_RESPONSE_CHANGED:
    "update_funder_details_response_changed",
  /*****************  UPDATE FUNDER DETAILS END  *******************/

  /*****************  DELETE FUNDER DETAILS START  *******************/
  DELETE_FUNDER_DETAILS_START: "delete_funder_details_start",
  DELETE_FUNDER_DETAILS_SUCCESS: "delete_funder_details_success",
  DELETE_FUNDER_DETAILS_FAILURE: "delete_funder_details_failure",
  DELETE_FUNDER_DETAILS_RESPONSE_RESET: "delete_funder_details_response_reset",
  DELETE_FUNDER_DETAILS_RESPONSE_CHANGED:
    "delete_funder_details_response_changed",
  /*****************  DELETE FUNDER DETAILS END  *******************/

  /*****************  FETCH FUNDER DETAILS START  *******************/
  FETCH_FUNDER_DETAILS_START: "fetch_funder_details_start",
  FETCH_FUNDER_DETAILS_SUCCESS: "fetch_funder_details_success",
  FETCH_FUNDER_DETAILS_FAILURE: "fetch_funder_details_failure",
  FETCH_FUNDER_DETAILS_RESPONSE_RESET: "fetch_funder_details_response_reset",
  FETCH_FUNDER_DETAILS_RESPONSE_CHANGED:
    "fetch_funder_details_response_changed",
  /*****************  FETCH FUNDER DETAILS END  *******************/

  /*****************  FETCH LIST  FUNDER DETAILS START  *******************/
  FUNDER_LIST_FETCH_START: "funder_list_fetch_start",
  FUNDER_LIST_FETCH_SUCCESS: "funder_list_fetch_success",
  FUNDER_LIST_FETCH_FAILURE: "funder_list_fetch_failure",
  FUNDER_LIST_RESPONSE_RESET_START: "funder_list_response_reset_start",
  FUNDER_LIST_FETCH_RESPONSE_CHANGED: "funder_list_fetch_response_changed",
  /*****************  FETCH  LIST FUNDER DETAILS END  *******************/
};
export default FunderActionTypes;
